import { render, staticRenderFns } from "./ios_prompt.vue?vue&type=template&id=d67f62e4&lang=pug&"
import script from "./ios_prompt.vue?vue&type=script&lang=coffee&"
export * from "./ios_prompt.vue?vue&type=script&lang=coffee&"
import style0 from "./ios_prompt.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ios_prompt.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports